import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { CaseManagementService } from '../../../services/caseManagement.service';

@Component({
  selector: 'add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent implements OnInit {

  woNoteDescription: any;
  loading: boolean;
  woServiceKey: any;

  constructor(
    public dialogRef: MatDialogRef<AddNotesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private caseManagementService: CaseManagementService,
  ) { }

  ngOnInit() {
    this.woServiceKey = this.caseManagementService.getWorkOrderKey();
    if (this.woServiceKey == undefined) {
      this.woServiceKey = this.data.WONumber;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveWoNote() {
    if (this.woNoteDescription === '' || this.woNoteDescription == undefined) {
      alert('Please enter workorder note.');
    } else {
      let data = {
        'adminView': true,
        'noteDate': this.datePipe.transform(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        'notePurpose': 'customer',
        'noteText': this.woNoteDescription,
        'userKey': sessionStorage.getItem('legacyCustomerKeyId'),
        'woKey': this.woServiceKey
      }
      this.loading = true;
      this.caseManagementService.saveWoNote(data).subscribe(res => {
        this.loading = false;
        this.woNoteDescription = '';
        this.dialogRef.close(1);

      }, (error) => {
        this.loading = false;
        console.error('AddNotesComponent_saveWoNote', error);
      });
    }
  }

}
